/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityTrendBySeverityRequest extends models.AppSecopsTimeRangeFilter {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityTrendBySeverityRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityTrendBySeverityRequest>): AppSecopsVulnerabilityTrendBySeverityRequest {
        let obj = Object.assign(new AppSecopsVulnerabilityTrendBySeverityRequest(), model);
        AppSecopsVulnerabilityTrendBySeverityRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityTrendBySeverityRequest>): AppSecopsVulnerabilityTrendBySeverityRequest {
        if (!model) return null;
        return AppSecopsVulnerabilityTrendBySeverityRequest.newInstance(<AppSecopsVulnerabilityTrendBySeverityRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityTrendBySeverityRequest) {
        if (!obj) return;

        models.AppSecopsVulnerabilityTrendBySeverityRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityTrendBySeverityRequest): boolean {
        if (models.AppSecopsTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityTrendBySeverityRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Granularity for aggregating vulnerability trend data
     */
    granularity: models.TrendGranularity;

}
